import React, { Component, useEffect } from 'react';
import { connect } from 'react-redux'
import MediaQuery from 'react-responsive';
import { getProcessUrls } from '../../api/apiConstants';

let bookURL = getProcessUrls['bookUrl'];
let wwwUrl = getProcessUrls['wwwUrl'];

const SpaHeader = ( { services } ) => {
	let { authDetails = {} } = services;
	let { appTrigger = 'CP' } = authDetails;

	useEffect(() => {
		const headerScript = document.createElement('script');
		const navScript = document.createElement('script');

		headerScript.src = `${bookURL}/js/personalizer/web-components/mb-global-header/mb-global-header.js`;
		headerScript.async = true;
		
		navScript.src = `${bookURL}/js/personalizer/web-components/mb-global-nav-menu/mb-global-nav-menu.js`;
		navScript.defer = true;
	
		document.body.appendChild(headerScript);
		document.body.appendChild(navScript);

		return () => {
			document.body.removeChild(headerScript);
			document.body.removeChild(navScript);
		}
	}, []);

	if (appTrigger !== 'CP') return;
	
	return (
		<div className='header-container'>
			<mb-global-header></mb-global-header>
			<mb-nav-menu></mb-nav-menu>	
		</div>
	);
}

const mapStateToProps = (state) => {
    return {
        services: state.services,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: {},
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SpaHeader)


